export const Role = {
    SIGNATORY : 1,
    ADMIN: 2,
    ADMIN_INFORMATION_SECURITY: 3,
    ADMINS: [2, 3]
}